//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from "vuex";
import QAuModelPicker from "@/components/Generics/ModelPicker/qAuModelPicker.vue";
import qAuModelTreeLight from "@/components/Generics/ModelTreeLight/qAuModelTreeLight.vue";
import AQModal from "@/components/Generics/AQModal/AQModal.vue";
import AQCard from "@/components/Generics/AQCard/AQCard.vue";
import AQDialog from "@/components/Generics/AQDialog/AQDialog.vue";

export default {
    name: "ExposeApiDefineRequest",
    components: {
        QAuModelPicker,
        qAuModelTreeLight,
        AQModal,
        AQDialog,
        AQCard
    },
    props: {
        requestObject: Array
    },
    data() {
        return {
            defineRequestModal: false,
            currentStep: "request",
            dataForModelTree: [],
            requestDefined: false,
            objToSend: {},
            isDirty: false,
            computedDataForModelTree: [],
            showDirtyDialog: false,
            data: []
        };
    },
    computed: {
        ...mapGetters("diagrams", ["selectedPluginConfigData"]),
        hasPrimary() {
            return {
                label: this.$t("generic.done"),
                disabled: !this.isDirty
            };
        }
    },
    mounted() {
        if (this.requestObject && this.requestObject.length) {
            this.computedDataForModelTree = this.requestObject;
            this.requestDefined = true;
        } else if (this.selectedPluginConfigData && this.selectedPluginConfigData.apiConfigure
        && this.selectedPluginConfigData.apiConfigure.dataExposeApi.length) {
            this.data.push(this.selectedPluginConfigData.apiConfigure.requests);
            this.data.push(this.selectedPluginConfigData.apiConfigure.dataExposeApi[0].requestDataModel);
            this.requestDefined = true;
            this.data.push({ requestVariable: this.requestDefined });
            this.computedDataForModelTree = this.selectedPluginConfigData.apiConfigure.dataExposeApi[0].requestDataModel;
            this.$emit("dataToSave", this.data);
        }
    },
    methods: {
        afterHide() {
            this.$emit("input", false);
        },
        openModal() {
            this.defineRequestModal = true;
            this.isDirty = false;
        },
        onModelSelect(modelSelect) {
            this.dataForModelTree = [];
            this.objToSend = {};
            modelSelect.forEach(elem => {
                this.dataForModelTree.push(elem.formatted);
                if (!elem.isEmbeded) {
                    const { parents = [] } = elem;
                    this.objToSend[elem.key] = elem.formatted;
                    if (parents.length && parents[0].node.isList) {
                        for (let i = 0; i < parents.length; i++) {
                            if (parents[i].node.isList) {
                                this.objToSend[`${parents[i].key}._path_`] = parents[i].formatted;
                            }
                        }
                    }
                }
            });
            this.isDirty = !!modelSelect.length;
        },
        defineRequestAction(action) {
            if (action === "primary") {
                this.data = [];
                this.requestDefined = true;
                this.data.push(this.objToSend);
                this.data.push(this.dataForModelTree);
                this.computedDataForModelTree = this.dataForModelTree;
                this.data.push({ requestVariable: this.requestDefined });
                this.defineRequestModal = false;
                this.$emit("dataToSave", this.data);
            } else if (action === "close") {
                if (this.isDirty) {
                    this.showDirtyDialog = true;
                } else {
                    this.requestDefined = !!this.computedDataForModelTree.length;
                    this.$emit("showButton", this.requestDefined);
                    this.defineRequestModal = false;
                }
            }
        },
        dialogConfirmAction(response) {
            if (response === "ok") {
                this.requestDefined = !!this.computedDataForModelTree.length;
                this.$emit("showButton", this.requestDefined);
                this.defineRequestModal = false;
            } else {
                this.showDirtyDialog = false;
            }
        }
    }
};

